// src/component/PLMImplementation/BusinessProcessAndChangeManagement/SolutionsPage.jsx

import "./SolutionsPage.css";
import React, { useLayoutEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import Banner from "../Banner/Banner";
import FloatingContactUs from "../../floting_contact/FloatingContactUs";
import SolutionOverview from "./SolutionOverview";
import Letsgetintouch from "./Letsgetintouch";

import BannerImage from "../../../assets/other_image/change_management.jpg";
import { NavLink } from "react-router-dom";
import { Helmet } from "react-helmet-async";

gsap.registerPlugin(ScrollTrigger);

const SolutionsPage = () => {
  const benefitsRef = useRef(null);
  const solutionsRef = useRef(null);
  const whyRef = useRef(null);

  useLayoutEffect(() => {
    const animate = (ref, x = 0, y = 60) => {
      gsap.from(ref.current, {
        opacity: 0,
        x,
        y,
        duration: 1.4,
        ease: "power3.out",
        scrollTrigger: {
          trigger: ref.current,
          start: "top 85%"
        }
      });
    };

    animate(benefitsRef, -80);
    animate(solutionsRef, 80);
    animate(whyRef, 0, 80);
  }, []);

  return (
    <>
      <Helmet>
        <title>Teamcenter Business Process &amp; Change Management | NexTech PLM</title>
        <meta name="description" content="Transform your business processes with Nextech PLM’s Teamcenter solutions. Manage changes effectively, boost productivity, and streamline operations. Talk to our experts today!" />
        <meta name="keywords" content="Teamcenter business process management, change management PLM, workflow management Pune, Teamcenter change management services, PLM process optimization India" />
        <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
        <link rel="canonical" href="https://nextechplm.com/teamcenter-business-process-management" />
        <meta property="og:site_name" content="NexTech PLM" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Teamcenter Business Process Management | NexTech PLM" />
        <meta property="og:description" content="Automate workflows, manage approvals, and optimize product lifecycle processes with Teamcenter Business Process Management solutions for greater efficiency and control." />
        <meta property="og:url" content="https://nextechplm.com/teamcenter-business-process-management" />
        <meta property="og:image" content="https://nextechplm.com/static/media/business-process-change-management.5fbea5796b84847df1f4.jpg" />
        <meta name="publisher" content="NexTech PLM" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Teamcenter Business Process Management | NexTech PLM" />
        <meta name="twitter:description" content="Automate workflows, manage approvals, and optimize product lifecycle processes with Teamcenter Business Process Management solutions for greater efficiency and control." />
        <meta name="twitter:image" content="https://nextechplm.com/static/media/business-process-change-management.5fbea5796b84847df1f4.jpg" />
      </Helmet>

      <Banner image={BannerImage} heading="Teamcenter Business Process & Change Management" />
      <FloatingContactUs />
      <SolutionOverview />

      {/* BENEFITS */}
      <section ref={benefitsRef} className="cinematic-section">
        <div className="container">
          <h4 className="solution-page-heading typewriter">Unlock the Power :</h4>
          <h5 className="solution-subheading">
            Transformative Benefits of Business Process with NexTech
          </h5>

          <ul className="custom-bullets">
            <li>Most up-to-date workflow visibility</li>
            <li>Reinforced best practices & error reduction</li>
            <li>Better change impact assessment</li>
            <li>Reduced delays & clearer change flow</li>
            <li>Improved lifecycle quality</li>
            <li>Better non-conformance prevention</li>
          </ul>
        </div>
      </section>

      {/* SOLUTIONS */}
      <section ref={solutionsRef} className="cinematic-section-light">
        <div className="container solutions">
          <div className="row">

            <div className="col-md-6 col-12">
              <h4 className="solution-page-heading typewriter">Teamcenter Solutions</h4>
              <ul className="custom-bullets">
                <li>Digital Workflow Management</li>
                <li>Change Management</li>
                <li>Issue Management</li>
                <li>CAPA</li>
                <li>Quality Management</li>
              </ul>
            </div>

            <div className="col-md-6 col-12">
              <div className="quick-links cinematic-appear">
                <h4>Quick Links</h4>
                <ul>
                  <li><NavLink to="/teamcenter/plm-document-management">Document Management</NavLink></li>
                  <li><NavLink to="/teamcenter/manufacturing-data-process-management">Manufacturing Data</NavLink></li>
                  <li><NavLink to="/teamcenter/product-bom-variability-management">Product BOM</NavLink></li>
                  <li><NavLink to="/teamcenter/community-collaboration">Community Collaboration</NavLink></li>
                  <li><NavLink to="/teamcenter/cloud-implementation">Cloud Implementation</NavLink></li>
                  <li><NavLink to="/teamcenter/ecad-integration">ECAD Integration</NavLink></li>
                  <li><NavLink to="/teamcenter/mcad-integration">MCAD Integration</NavLink></li>
                </ul>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* WHY NEXTECH */}
      <section ref={whyRef} className="cinematic-section">
        <div className="container why-nextech">
          <h4 className="solution-page-heading typewriter">Why NexTech?</h4>
          <h5 className="solution-subheading">For Business Processes & Change Management</h5>

          <ul className="custom-bullets">
            <li>Automated PLM workflow systems</li>
            <li>End-to-end closed-loop change</li>
            <li>Issue Management & CAPA</li>
            <li>Holistic quality + workflow + engineering process chain</li>
            <li>Eliminates gaps & boosts product quality</li>
          </ul>
        </div>
      </section>

      <Letsgetintouch />
    </>
  );
};

export default SolutionsPage;
